var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-content"},[(_vm.closable)?_c('button',{staticClass:"close-btn",attrs:{"title":"Закрыть"},on:{"click":_vm.handleClose}},[_c('BaseIcon',{attrs:{"glyph":"close"}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }